import React from 'react'
import { Tooltip } from '@material-ui/core'
import { BusinessGroupCellContainer } from './styled'

const BusinessGroupCell = (props) => {
  const { title, companyCodes, onClick } = props

  const generateTooltipText = () => {
    var toolTipText = 'Click to select companies' + companyCodes.map(c => ` ${c}`)

    return toolTipText
  }

  return (
    <Tooltip title={generateTooltipText()} placement='top'>
      <BusinessGroupCellContainer onClick={() => onClick(companyCodes)}>
        {title}
      </BusinessGroupCellContainer>
    </Tooltip>
  )
}

BusinessGroupCell.defaultProps = {
  title: '',
  companyCodes: []
}

export default BusinessGroupCell